import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory, Link } from "react-router-dom";
import {
  stringIsNullOrEmpty,
  isObjectEmpty,
  numberWithCurrencyFormat,
  createFormBody,
  createMultiPartFormBody
} from "../../util/Util";
import {
  WebUrl,
  ApiUrl,
  ApiKey,
  LanguageOption,
  SessionKey,
  Language,
  LanguageSelectStyle,
  getReferralCodeByDomain
} from "../../util/Constant";
import { setRegisterModal } from "../../redux/AppAction.js";

const DesktopFooter = () => {
  var { t, i18n } = useTranslation();
  const _history = useHistory();
   var _dispatch = useDispatch();

  const [channels, setChannels] = useState([]);
  var { isLoggedIn } = useSelector((state) => state.authState);

    useEffect(() => {
      fetch(ApiUrl._API_GET_COMMUNICATION_CHANNELS + "?all=true", {
        method: ApiKey._API_GET,
        headers: {
          "Content-Type": ApiKey._API_FORM_URLENCODED,
          "X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
        },
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setChannelData(responseJson[ApiKey._API_DATA_KEY]);
          }
        });
    }, []);
  
    function setChannelData(data) {
      var channels = [];
      data.map((d, index) => {
        var channel = {
          name: d.channelName,
          description: d.channelDescription,
          actionUrl: d.cta,
          image: d.channelImage,
          attachment: d.attachment,
        };
  
        channels.push(channel);
      });
      setChannels(channels);
    }

  const handleOpenRegister = () => {
    if(isLoggedIn) {
      _history.push(WebUrl._URL_DC_REDEMPTION);
    } else {
      const domainCode = getReferralCodeByDomain(window.location.hostname);
      if (domainCode){
        const registerUrl = WebUrl._URL_MLMCREATEANACCOUNT + "?code=" + (domainCode ?? "");
        _history.push(registerUrl);
      }
      else{
        _dispatch(setRegisterModal(true));
      }
    }
  };

  function handleClick(channel) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: "chat",
          //url: `${channel.actionUrl}`,
          url:
            channel.actionUrl.match(/live-chat/i) != null
              ? `${window.location.origin}${channel.actionUrl}`
              : `${channel.actionUrl}`,
        })
      );
    } else {
      window.location.href = channel.actionUrl;
    }
  }

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional: for smooth scrolling
    });
  };

  return (
    <footer className="footer">
      <Link 
        to={WebUrl._URL_LIVECHAT} 
        className="floating-button" 
        style={{ display: (window.location.pathname !== '/livechat' ? 'block' : 'none') }}
      >
        {localStorage.getItem("totalUnreadLiveChat") > 0 && (
          <span className="badge-live-chat">
            {localStorage.getItem("totalUnreadLiveChat")}
          </span>
        )}
      </Link>
      <div className="full-content-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h5>{t("FOOTER_TITLE_1")}</h5>
            <div dangerouslySetInnerHTML={{ __html: t("FOOTER_WRITEUP_1").replace('\n', '<br/>') }}></div>
            <br/>
            
            <h5>{t("FOOTER_TITLE_2")}</h5>
            <ul className="footer-links">
              <li>ABA BANK</li>
              <li>ACLEDA BANK</li>
              <li>WING BANK</li>
              <li>USDT</li>
              {/* <li>TOPKASH</li>
              <li>HUIONE</li>
              <li>WING WEILUY</li> */}
            </ul>

          </div>
          <div className="footer-section">
            <h5>{t("FOOTER_TITLE_3")}</h5>
            <div dangerouslySetInnerHTML={{ __html: t("FOOTER_WRITEUP_2").replace('\n', '<br/>') }}></div>
            <br/>

            <h5>{t("RESPONSIBLE_GAMBLING")}</h5>
            <div dangerouslySetInnerHTML={{ __html: t("FOOTER_WRITEUP_3").replace('\n', '<br/>') }}></div>
            <br/>

            <h5>{t("INFORMATION")}</h5>
            <ul className="footer-links">
              <li><Link to={WebUrl._URL_CONTENT_PAGE + "?page=About"} onClick={() => handleScrollToTop()}>{t("ABOUT_US")}</Link></li>
              <li><Link to={WebUrl._URL_CONTENT_PAGE + "?page=TnC"} onClick={() => handleScrollToTop()}>{t("TERMS_AND_CONDITIONS")}</Link></li>
              <li><Link to={WebUrl._URL_CONTENT_PAGE + "?page=Privacy"} onClick={() => handleScrollToTop()}>{t("PRIVACY_POLICY")}</Link></li>
              {/*<li><Link to="#">{t("AFFILIATE_PARTNER_PROGRAM")}</Link></li>*/}
            </ul>


          </div>
          <div className="footer-section">
            <h5>{t("PROMOTION")}</h5>
            <div>{t("FOOTER_WRITEUP_4")}<br/><Link to={WebUrl._URL_FS_PROMOTION} onClick={() => handleScrollToTop()}>Learn More.</Link></div>
            <br/>
            
            <h5>{t("VIP_PROGRAM")}</h5>
            <div>{t("FOOTER_WRITEUP_5")}<br/><Link to={WebUrl._URL_VIP_BENEFITS} onClick={() => handleScrollToTop()}>Join Now.</Link></div>
            <br/>

            <h5>{t("COMMISSION")}</h5>
            <div>{t("FOOTER_WRITEUP_6")}<br/><Link to={WebUrl._URL_COMMISSIONS_INFO} onClick={() => handleScrollToTop()}>Earn Now.</Link></div>
            <br/>
            
            <h5>{t("FOOTER_TITLE_4")}</h5>
            <div>{t("FOOTER_WRITEUP_7")}<br/><Link to={WebUrl._URL_LIVECHAT} onClick={() => handleScrollToTop()}>Chat Now.</Link></div>
            <br/>
            
            <h5>{t("FOOTER_TITLE_5")}</h5>
            <div>{t("FOOTER_WRITEUP_8")}<br/><Link to={WebUrl._URL_LIVECHAT} onClick={() => handleScrollToTop()}>Become An Affiliate Today!</Link></div>
            <br/>
            
            <h5>{t("FOOTER_TITLE_6")}</h5>
            <div>{t("FOOTER_WRITEUP_9")}<br/>
              <a 
                className="cursor-pointer" 
                onClick={() =>  handleOpenRegister()}
              >
                Register for Free!
              </a>
            </div>

          </div>
        </div>
        <div className="footer-grid footer-second-section">
          <div className="footer-section">
            <h5>{t("Follow Us")}</h5>
            <div className="social-links">
              <a href="https://www.facebook.com/okup.page" target="_blank" className="social-link" title="Facebook">
                <img
                  src={require("../../assets/img/desktop/footer/fb.png")}
                  className="img-responsive"
                  alt="okup"
                  loading="lazy"
                />
              </a>
              <a href="https://www.youtube.com/@OkupOfficial" target="_blank" className="social-link" title="youtube">
                <img
                  src={require("../../assets/img/desktop/footer/yt.png")}
                  className="img-responsive"
                  alt="okup"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h5>{t("Contact Us")}</h5>
            <div className="social-links">
              {channels.map((channel, index) => {
                if(channel.name != "Facebook"){
                  return (
                    <a 
                      key={index}
                      onClick={() => {
                        if (!stringIsNullOrEmpty(channel.actionUrl)) {
                          handleClick(channel);
                        } else if (channel.name == "Livechat") {
                          _history.push(WebUrl._URL_LIVECHAT);
                        }
                      }}
                      className="social-link cursor-pointer" 
                      title={channel.name + " Okup"}
                    >
                      <img
                        src={channel.image}
                        className="img-responsive"
                        alt="okup"
                        loading="lazy"
                      />
                    </a>
                  );
                }
              })}
              {/* <a href="https://t.me/OkUpOfficial" target="_blank" className="social-link" title="telegram">
                <img loading="lazy"
                  src={require("../../assets/img/desktop/footer/telegram.png")}
                  className="img-responsive"
                  alt="okup"
                />
              </a>
              <a href="#" className="social-link" title="Line">
                <img loading="lazy"
                  src={require("../../assets/img/desktop/footer/line.png")}
                  className="img-responsive"
                  alt="okup"
                />
              </a>
              <a href="#" className="social-link" title="whatsapp">
                <img loading="lazy"
                  src={require("../../assets/img/desktop/footer/wa.png")}
                  className="img-responsive"
                  alt="okup"
                />
              </a> */}
            </div>
          </div>
          <div className="footer-section">
            <h5>{t("Responsive Gaming")}</h5>
            <img
              src={require("../../assets/img/desktop/footer/responsive-gaming.png")}
              className="img-responsive"
              alt="okup"
              loading="lazy"
            />
          </div>
          <div className="footer-section">
            <h5>{t("Licenses")}</h5>
            <a href="https://validate.thetgc.cc/validate?domain=okup.app&seal_id=73b75cbceb56758d42aa636755a5ad333222bedf6c47e3135d4dc951d64770afbacf57ab8c53ccd696b80abff91e325b&stamp=0fa08af549fede398e7f744e0adea593" target="_blank">
              <img
                src={require("../../assets/img/desktop/footer/license.png")}
                className="img-responsive"
                alt="okup"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        {/* Footer Bottom */}
        <div className="footer-bottom">
            <p>Copyright &copy; 2025 OKUP. {t("All rights reserved")}.</p>
        </div>
      </div>
    </footer>
  );
};

export default DesktopFooter;